import './DataAccessCompareButton.scss';

import { AccessComparisonQueryParams } from '@hooks';
import { Button } from 'antd';
import { getQueryString } from '@sonar-software/sonar-http';
import { NoCompactStyle } from 'antd/es/space/Compact';
import { SearchOption } from '@dictionary/search';
import { useNavigate } from 'react-router';

import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';

interface DataAccessCompareOptionProps {
	option: SearchOption;
}

export const DataAccessCompareOption: React.FC<DataAccessCompareOptionProps> = ({ option }) => {
	const navigate = useNavigate();

	const handleCompareClick = useCallback((
		e: React.MouseEvent<HTMLButtonElement, MouseEvent>
	) => {
		e.preventDefault();
		e.stopPropagation();

		if (!option.value || !option.type) {
			return;
		}

		const queryString: AccessComparisonQueryParams = {
			accessId: [ option.value as string ],
			accessType: [ option.type ]
		};

		navigate(
			`${FULL_ROUTES.DATA_SECURITY_DATA_ACCESS_ACCESS_COMPARE}?${getQueryString(queryString)}`
		);
	}, [ navigate, option ]);

	return (
		<div className='custom-option'>
			<span className='option-label'>{ option.label }</span>
			<NoCompactStyle>
				<Button
					className='compare-btn'
					onClick={ handleCompareClick }
					onMouseDown={ (e) => {
						e.preventDefault();
						e.stopPropagation();
					} }
					size='small'
					type='primary'>
					{ COPY_SPECIFIC.COMPARE }
				</Button>
			</NoCompactStyle>
		</div>
	);
};
